// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import AccordionController from "./accordion_controller"
application.register("accordion", AccordionController)

import BookingDetailsController from "./booking_details_controller"
application.register("booking-details", BookingDetailsController)

import CachedSearchController from "./cached_search_controller"
application.register("cached-search", CachedSearchController)

import CarouselController from "./carousel_controller"
application.register("carousel", CarouselController)

import ClipboardController from "./clipboard_controller"
application.register("clipboard", ClipboardController)

import FlashMessageController from "./flash_message_controller"
application.register("flash-message", FlashMessageController)

import GoogleMapsController from "./google_maps_controller"
application.register("google-maps", GoogleMapsController)

import HomeMapPanelController from "./home_map_panel_controller"
application.register("home-map-panel", HomeMapPanelController)

import HomeWayPanelController from "./home_way_panel_controller"
application.register("home-way-panel", HomeWayPanelController)

import InfoPanelController from "./info_panel_controller"
application.register("info-panel", InfoPanelController)

import LinkController from "./link_controller"
application.register("link", LinkController)

import MenuController from "./menu_controller"
application.register("menu", MenuController)

import ModalController from "./modal_controller"
application.register("modal", ModalController)

import NavigationController from "./navigation_controller"
application.register("navigation", NavigationController)

import ObfuscatedLinkController from "./obfuscated_link_controller"
application.register("obfuscated-link", ObfuscatedLinkController)

import ProfileSelectorController from "./profile_selector_controller"
application.register("profile-selector", ProfileSelectorController)

import ProgressBarController from "./progress_bar_controller"
application.register("progress-bar", ProgressBarController)

import RevealController from "./reveal_controller"
application.register("reveal", RevealController)

import ScrollToController from "./scroll_to_controller"
application.register("scroll-to", ScrollToController)

import SleepLayersController from "./sleep_layers_controller"
application.register("sleep-layers", SleepLayersController)

import SleepMapController from "./sleep_map_controller"
application.register("sleep-map", SleepMapController)

import SleepMarkersController from "./sleep_markers_controller"
application.register("sleep-markers", SleepMarkersController)

import SliderController from "./slider_controller"
application.register("slider", SliderController)

import TextareaController from "./textarea_controller"
application.register("textarea", TextareaController)

import TimerController from "./timer_controller"
application.register("timer", TimerController)

import ToggleViewController from "./toggle_view_controller"
application.register("toggle-view", ToggleViewController)

import TurboModalController from "./turbo_modal_controller"
application.register("turbo-modal", TurboModalController)

import WizardController from "./wizard_controller"
application.register("wizard", WizardController)

import MemberBookingActionsController from "./member_booking_actions_controller"
application.register("member-booking-actions", MemberBookingActionsController)

import ElevationProfileController from "./elevation_profile_controller"
application.register("elevation-profile", ElevationProfileController)
